<ng-container *ngIf="categoryLoading; else loadingDone">
    <div class="py-5 text-center">
        <app-loader></app-loader>
    </div>
</ng-container>

<ng-template #loadingDone>
    <ng-container *ngIf="readonly; else editable">
        <div class="py-3">
            <div class="card p-4 mx-auto" style="max-width: 640px">
                <div class="text-muted small text-uppercase mb-1">{{ "Category" | translate }}</div>
                <h5 class="mb-3">{{ selectedCategoryFullName }}</h5>
                <div class="text-center">
                    <button type="button" class="btn btn-primary" (click)="confirmReadonly()">
                        {{ "Next" | translate }} <span class="bi ps-2 bi-arrow-right"></span>
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #editable>
    <!-- Header Section -->
    <div class="category-header text-center mb-4">
        <h4 class="fw-semibold mb-3">{{ "Select the category for your offer" | translate }}</h4>

        <!-- Breadcrumb Navigation -->
        <div class="breadcrumb-nav" *ngIf="selectedPath.length > 0">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb justify-content-center mb-3">
                    <li class="breadcrumb-item">
                        <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="navigateToRoot()">
                            <i class="bi bi-house-door me-1"></i>
                            {{ "Categories" | translate }}
                        </button>
                    </li>
                    <li
                        class="breadcrumb-item"
                        *ngFor="let category of selectedPath; let isLast = last; let i = index"
                        [class.active]="isLast"
                    >
                        <ng-container *ngIf="!isLast">
                            <button type="button" class="btn btn-link p-0 text-decoration-none" (click)="navigateToLevel(i)">
                                {{ category.name }}
                            </button>
                        </ng-container>
                        <span *ngIf="isLast">{{ category.name }}</span>
                    </li>
                </ol>
            </nav>
        </div>
    </div>

    <!-- Categories Grid -->
    <div class="categories-container">
        <div class="row g-3">
            <div class="col-6 col-md-4 col-lg-3" *ngFor="let category of currentCategories">
                <div class="category-card" (click)="navigateToCategory(category)">
                    <!-- Category Image -->
                    <div class="category-image-container">
                        <app-picture
                            *ngIf="category.imageId"
                            [picture]="category.imageId"
                            aspectRatio="1:1"
                            bgSize="cover"
                            [default]="'assets/images/category-placeholder.svg'"
                        >
                        </app-picture>
                        <div class="category-image-placeholder" *ngIf="!category.imageId">
                            <i class="bi bi-grid-3x3-gap-fill"></i>
                        </div>
                    </div>

                    <!-- Category Info -->
                    <div class="category-info">
                        <div class="d-flex justify-content-between align-items-center">
                            <h6 class="category-name mb-0">{{ category.name }}</h6>
                            <i class="bi bi-chevron-right text-muted" *ngIf="hasChildren(category)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state text-center py-5" *ngIf="currentCategories.length === 0 && !categoryLoading">
        <i class="bi bi-grid-3x3-gap display-4 text-muted mb-3"></i>
        <h6 class="text-muted">{{ "No categories available" | translate }}</h6>
    </div>
</ng-template>
